// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"c66b5114","122":"48e7dc59","360":"3e74ccfb","396":"0d32827b","554":"0d32827b","778":"4ff0d311","821":"5ef2dce4"}[chunkId] + ".chunk.css";
};